'use client';

import React from 'react';
import { HStack, Text } from '@ui-library';
import { ArrowRight } from '@ui-library/icons';

import useLocalization from '@/hooks/useLocalization';
import { formatDateWithTimezone } from '@/components/check-in/components/utils';

import { getMediumDateFormat, PropertyDateFormat } from '@/lib/dateFormat';

type DateRangeDisplayProps = {
  startDate: string;
  endDate: string;
  companyTimezone: string;
  color?: string;
  format?: string;
  propertyDateFormat?: PropertyDateFormat;
};

export const DateRangeDisplay = ({
  startDate,
  endDate,
  companyTimezone,
  color = 'lightning.500',
  format,
  propertyDateFormat,
}: DateRangeDisplayProps) => {
  const resolvedFormat = format || getMediumDateFormat(propertyDateFormat);
  const { dateFnsLocale } = useLocalization();

  const formattedStartDate = formatDateWithTimezone(
    startDate,
    companyTimezone,
    dateFnsLocale,
    resolvedFormat,
  );

  const formattedEndDate = formatDateWithTimezone(
    endDate,
    companyTimezone,
    dateFnsLocale,
    resolvedFormat,
  );

  return (
    <HStack gap={1} color={color}>
      <Text fontSize="sm" fontWeight="normal" color={color}>
        {formattedStartDate}
      </Text>
      <ArrowRight size={14} />
      <Text fontSize="sm" fontWeight="normal" color={color}>
        {formattedEndDate}
      </Text>
    </HStack>
  );
};
